__turbopack_context__.v({
  "root": "ProductReviewsAndAnswersContainer-module-scss-module__MCZl3a__root",
});
